import React from 'react';
import BookingContainerConnector from './BookingContainerConnector';

export const BookingContainerWrapper = (props) => (
    <BookingContainerConnector {...props} />
);
